/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportMarketingMessageViewed} from '../api'

export const useMutationReportMarketingMessageViewed = createReactQueryMutationHook('reportMarketingMessageViewed', reportMarketingMessageViewed)
